import React__default from 'react';
import '../../../styles/general.css.js';

const vAlign = {
    center: 'center',
    top: 'flex-start',
    bottom: 'flex-end',
};
const hAlign = {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end',
};
const Stack = ({ direction = 'column', verticalAlign = 'center', horizontalAlign = 'left', distribute, padding, gap, children, onClick, }) => {
    return (React__default.createElement("div", { className: onClick ? 'noselect' : '', style: {
            cursor: onClick ? 'pointer' : '',
            display: 'inline-flex',
            flexDirection: direction,
            padding: padding,
            gap: gap,
            alignItems: vAlign[verticalAlign],
            justifyContent: distribute ? distribute : hAlign[horizontalAlign],
        }, onClick: onClick }, children));
};

export { Stack as default };
//# sourceMappingURL=Stack.js.map
